import { Grid, Stack, Typography } from '@mui/material'
import { CarrierType } from '@planning/app/api'
import { OrderHoldsSection } from '@planning/components/hold/organisms/OrderHoldsSection'
import { OrderHoldsSectionStore } from '@planning/components/hold/organisms/stores/OrderHoldsSectionStore'
import { DirectionalCargoDetailsType } from '@planning/pages/Order/V2/organisms/DirectionalCargoDetailsSubForm'
import { CargoDetailsSubFormStore } from '@planning/pages/Order/V2/stores/CargoDetailsSubFormStore'
import { OrderFormStore, OrderFormStoreType } from '@planning/pages/Order/V2/stores/OrderFormStore'
import { StowageInstructionAutocompleteViewStore } from '@planning/stores/stowageInstruction/StowageInstructionAutocompleteViewStore'
import { useTranslate } from '@tolgee/react'
import { RequiredField } from '@tom-ui/ui'
import { IFormStore } from '@tom-ui/utils'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { OrderAditionalCargoInformationCard } from '../organisms/OrderAditionalCargoInformationCard'
import { OrderCargoInformationCard } from '../organisms/OrderCargoInformationCard'
import { OrderSpecialHandlingCard } from '../organisms/OrderSpecialHandlingCard'

export const OrderCargoDetailsStep = observer(
  (props: {
    containerId: number
    formStore: OrderFormStore
    cargoDetailsFormStore: CargoDetailsSubFormStore
    directionalCargoDetailsFormStore: IFormStore<DirectionalCargoDetailsType>
    initialValues?: Partial<OrderFormStoreType>
    isFromRestowPage?: boolean
    holdsStore: OrderHoldsSectionStore
  }) => {
    const {
      formStore,
      cargoDetailsFormStore,
      directionalCargoDetailsFormStore,
      initialValues,
      isFromRestowPage,
      holdsStore,
    } = props

    const { t } = useTranslate()

    const hasCustoms = computed(() => {
      const hasCustoms =
        formStore.data?.outboundCargoDetails?.transport?.carrierType === CarrierType.Vessel
      return hasCustoms
    }).get()

    const hasDoorDirection = computed(() => {
      const hasDoorDirection =
        formStore.data?.outboundCargoDetails?.transport?.carrierType === CarrierType.Train
      return hasDoorDirection
    }).get()

    const stowageInstructionsAutocompleteViewStore = useMemo(
      () => new StowageInstructionAutocompleteViewStore(),
      [],
    )

    return (
      <Stack spacing={2}>
        <Typography variant='subtitle1'>
          {t('enterCargoInformation', 'Enter cargo information')} <RequiredField />
        </Typography>

        <OrderCargoInformationCard
          formStore={formStore}
          cargoDetailsFormStore={cargoDetailsFormStore}
          initialValues={initialValues}
          isFromRestowPage={isFromRestowPage}
        />

        <Grid container spacing={2} alignItems='flex-start'>
          <Grid size={6}>
            <OrderAditionalCargoInformationCard
              cargoDetailsFormStore={directionalCargoDetailsFormStore}
              hasDoorDirection={hasDoorDirection}
              hasCustoms={hasCustoms}
            />
          </Grid>
          <Grid size={6}>
            <OrderHoldsSection store={holdsStore} allowAdd />
          </Grid>
        </Grid>

        <OrderSpecialHandlingCard
          directionalCargoDetailsFormStore={directionalCargoDetailsFormStore}
          cargoDetailsFormStore={cargoDetailsFormStore}
          autoCompleteStore={stowageInstructionsAutocompleteViewStore}
          disableUnloadingMethod
        />
      </Stack>
    )
  },
)
